import React from 'react';
import { Container } from 'react-bootstrap';

import SEO from '@/components/common/SEO';

import TakedownForm from './TakedownForm';

import './TakedownPage.css';

export default function TakedownPage() {
    const seoDescription =
        'Submit a DMCA takedown request to report copyright infringement ' +
        'on Sustainability Hub. We take intellectual property rights seriously ' +
        'and will review all legitimate claims.';

    return (
        <div id="takedown-page" className="page-container">
            <SEO
                title="Content Takedown Request"
                description={seoDescription}
                canonical="/takedown"
            />
            <Container className="form-container">
                <TakedownForm />
            </Container>
        </div>
    );
}
